module.exports = __webpack_public_path__ + "assets/img/pop-foto.2121f71f.webp";